import styled from "styled-components";

export const SubmitReqPreSugestedPriceStyled = styled.div`
  border-radius: 10px;
  width: 100%;
  background-color: #2a2e43;
  text-align: center;
  color: white;
  font-weight: bold;
  padding: 5px;
  
`;
